import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// global style
import './styles/globalFixes.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out and remove the HTML splash screen after React mounts
window.addEventListener('load', () => {
  const splash = document.getElementById('barterfi-splash');

  if (!splash) return;

  // small delay so the transition feels smoother
  setTimeout(() => {
    splash.classList.add('bf-splash-hide');

    // remove from DOM after fade completes
    setTimeout(() => {
      splash.remove();
    }, 400);
  }, 150);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
